export default __webpack_public_path__ + "static/media/img-3.4f96363e.jpg";